// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__j8L9F","header":"ReportDetails_header__2YL1L","title":"ReportDetails_title__sCbCC","left":"ReportDetails_left__1SRo2"};